/**
* Created by bieao on 2020/4/1.
*/
<template>
  <div id='home-bg'>
    <!--canvas背景-->
    <Background></Background>
    <!--头部-->
    <Header :projectGroupInfo="projectGroupInfo" :current="currentProjectId"></Header>
    <!--项目信息-->
    <ProjectInfo :projectInfo="currentProjectInfo"></ProjectInfo>
    <!--概览-->
    <Overview :overview="craneOverview" ></Overview>
    <!--报警信息-->
    <AlarmMonitor :alarmList="alarmList" :peccancyList="peccancyList"></AlarmMonitor>
    <!--今日统计-->
    <StatisticsToday :data="staticsInfo"></StatisticsToday>
    <!--今日报警排名-->
    <StatisticsChart :alarmData="alarmChartData" :peccancyData="peccancyChartData"></StatisticsChart>
    <!--结构数据数据-->
    <CraneInformation :data="craneObj" :cranes="cranes"></CraneInformation>
    <!--添加摄像头-->
    <Camera @showVideoDiv = 'showVideoDiv' :data="clickVideoObj"></Camera>
    <!--3D塔机-->
    <ThreeDQunCraneTwo :screenChange="isScreenChange" :cranes="cranes" :config="areaConfig" :runData = 'runData' @getVideoUrl = 'getVideoUrl' @initFinish="callRequest"></ThreeDQunCraneTwo>
    <!--展示视频-->
    <Video class="drag" v-drag v-if="showVideo" :addr="videoAddr" :videoTitle='videoTitle' :craneName="craneName" @closeVideoDiv = 'closeVideoDiv'></Video>
    <!--知识产权-->
    <Bottom />
  </div>
</template>

<script>
import $ from 'jquery'
import dayjs from 'dayjs'
import Background from '@/components/Background'
import Header from '@/components/Header'
import ProjectInfo from '@/components/ProjectInfo'
import Overview from '@/components/Overview'
import AlarmMonitor from '@/components/AlarmMonitor'
import StatisticsToday from '@/components/StatisticsToday'
import StatisticsChart from '@/components/StatisticsChart'
import CraneInformation from '@/components/CraneInformation'
import ThreeDQunCraneTwo from '@/components/ThreeDQunCraneTwo'
import Bottom from '@/components/Bottom'
import Video from '@/components/Video'
import Camera from '@/components/Camera'
import {getProjectGroup, getProjectGroupConfig, getSingleProject, listProjectCrane, getConfig, getDayStaticData, getRealData, getRunData, getAlarmDetail, refreshToken} from '@/api/metric'
import {compare} from '@/utils/utils'

const formatter = 'YYYY-MM-DD'
const formatter2 = 'HH:mm:ss'
const detailType = {
  '0': '左转防碰撞',
  '1': '右转防碰撞',
  '2': '幅度出防碰撞',
  '3': '幅度进防碰撞',
  '4': '左转限制区',
  '5': '右转限制区',
  '6': '幅度出限制区',
  '7': '幅度进限制区',
  '8': '左转限位',
  '9': '右转限位',
  '10': '幅度出限位',
  '11': '幅度进限位',
  '12': '高度上限位',
  '13': '高度下限位',
  '14': '力',
  '15': '力矩',
  '16': '风速'
}
export default {
  name: 'home',
  data () {
    return {
      clickIndex: 0,
      loopTimer: null, // 实时数据轮询
      craneTimer: null, // 塔机定时轮询
      projectRequestTimer: null, // 项目轮询
      showVideo: false,
      videoAddr: null, // 视频专用
      craneName: '', // 视频专用
      videoTitle: '', // 视频专用
      craneObj: {
        id: null,
        alias: '', // 塔机名称
        towerHeight: 0, // 塔高
        craneType: 0, // 塔机类型
        jibArmLength: 0, // 起重臂长
        balanceArmLength: 0, // 平衡臂长
        craneFactoryName: '', // 厂商
        craneModelName: '', // 类型
        sectionLength: 0, // 标准节高度
        maxLoad: 0, // 额定吊重
        actualTowerHeight: 0,
        actualBalanceArmLength: 0,
        actualSectionHeight: 0
      }, // 当前点击的塔机
      alarmList: [], // 报警列表
      peccancyList: [], // 违章列表
      clickVideoObj: [],
      isClickClose: false,
      currentProjectInfo: {
        id: null,
        companyId: null,
        name: null,
        status: 0,
        address: null,
        manager: null,
        managerMobile: null,
        safetyDirector: null,
        safetyDirectorMobile: null,
        companyName: null,
        description: null
      },
      projectGroupInfo: {
        id: null,
        projectSet: [],
        name: null
      },
      craneOverview: {
        craneTotal: 0,
        online: 0,
        num110s: 0,
        numV610: 0
      },
      staticsInfo: {
        currentOnlineRate: 0,
        preOnlineRate: 0,
        currentAlarm: 0,
        currentTaJunAlarm: 0,
        preAlarm: 0,
        currentPeccancy: 0,
        currentTaJunPeccancy: 0,
        prePeccancy: 0,
        currentHangTimes: 0,
        currentTaJunHangTimes: 0,
        preHangTimes: 0,
        currentWorkTime: 0,
        currentTaJunWorkTime: 0,
        preWorkTime: 0
      },
      alarmChartData: [],
      peccancyChartData: [],
      data: {},
      craneList: [], // 存储全部请求完数据
      cranes: [],
      runDataList: [], // 存储全部请求完数据
      runData: [],
      areaConfig: {},
      isScreenChange: Math.random(),
      craneCameraObj: {},
      customObj: {},
      projects: [],
      currentProjectId: null,
      currentProjectIndex: 0,
      projectCranes: {}
    }
  },
  components: {
    Background,
    Header,
    ProjectInfo,
    Overview,
    AlarmMonitor,
    StatisticsToday,
    StatisticsChart,
    CraneInformation,
    ThreeDQunCraneTwo,
    Video,
    Camera,
    Bottom
  },
  methods: {
    getVideoUrl (craneId) {
      this.clearCraneTimer()
      this.timerClickRequest()
      this.craneObj = this.data[craneId]
      this.clickIndex = Object.keys(this.data).indexOf(craneId)
      if (!this.showVideo) {
        this.clickVideoObj = this.craneCameraObj[craneId]
      }
    },
    closeVideoDiv () {
      this.showVideo = false
    },
    showVideoDiv (item) {
      if (item) {
        this.showVideo = true
        const {name, positionName, curQuality, hlsUrl, hlshdUrl} = item
        this.craneName = name
        this.videoTitle = positionName
        this.videoAddr = curQuality ? hlshdUrl : hlsUrl
      }
    },
    // 获取组合项目
    getProjectGroup () {
      getProjectGroup(this.projectGroupInfo.id).then(res => {
        const {data, code} = res
        if (code === 200) {
          const {id, name, projectSet} = data
          this.projectGroupInfo = {id, name, projectSet}
          if (projectSet.length > 1) {
            this.getProjectGroupConfig()
          }
        }
      })
    },
    // 获取组合项目的配置
    getProjectGroupConfig () {
      getProjectGroupConfig(this.projectGroupInfo.id).then(res => {
        const {data, code} = res
        if (code === 200) {
          const {projects, rectObj} = data
          if (!projects.length || !rectObj) {
            message.error('请先关联并配置项目')
          } else {
            this.projects = projects
            const hasNoConfig = projects.length !== this.projectGroupInfo.projectSet.length
            if (hasNoConfig) this.projectGroupInfo.projectSet = []
            projects.forEach((obj) => {
              const {projectId, projectName, craneList} = obj
              if (hasNoConfig) this.projectGroupInfo.projectSet.push({id: projectId, name: projectName})
              if (craneList && craneList.length > 0) {
                this.projectCranes[projectId] = []
                craneList.forEach((item) => this.projectCranes[projectId].push(item.id))
              }
            })
            this.areaConfig = rectObj
            this.resolveCustomObj(data)
            const firstProjectId = projects[0].projectId
            this.currentProjectId = firstProjectId
            this.currentProjectIndex = 0
            this.getProjectCrane(firstProjectId, 0)
            this.getCurrentProject()
            this.clearProjectRequestTimer()
            this.currentProjectIndex = 1
            this.timerProjectRequest()
          }
        }
      })
    },
    // 获取当前项目的所有信息
    getCurrentProject () {
      this.getSingleProject()
      this.getRealData()
      this.getDayStaticData()
      this.getAlarmDetail()
      this.getPeccancyDetail()
    },
    // 处理数据
    resolveCustomObj (data) {
      const customObj = {}
      const {projects, rectObj} = data
      projects.forEach((res) => {
        const {craneList, projectId} = res
        if (craneList && craneList.length > 0) {
          customObj[projectId] = {}
          craneList.forEach((obj) => {
            const {id, areaList, armLength, balanceArmLength, screenX, screenY} = obj
            customObj[projectId][id] = {areaList, armLength, balanceArmLength, screenX, screenY}
          })
        }
      })
      customObj.rectObj = rectObj
      this.customObj = customObj
    },
    getProjectCrane (projectId, index) {
      listProjectCrane(projectId).then(res => {
        const {data, code} = res
        if (code === 200 && data.length) {
          data.forEach((obj) => {
            const {id, alias, craneNvrList} = obj
            const newCraneNvrList = (craneNvrList || []).map((item) => ({...item, name: alias}))
            this.craneCameraObj[id] = newCraneNvrList
          })
          this.getProjectConfig(projectId, index)
        }
      })
    },

    getSingleProject () {
      getSingleProject(this.currentProjectId).then(res => {
        const {data, code} = res
        if (code === 200 && !!data) {
          this.currentProjectInfo = {...this.currentProjectInfo, ...data}
          this.getProjectDayStaticData()
        }
      })
    },
    getProjectConfig (projectId, index) {
      getConfig(projectId).then(res => {
        const {data, code} = res
        if (code === 200) {
          let initOk = []
          const customObj = this.customObj[projectId]
          const {craneList} = data
          const newCraneList = craneList.filter((obj) => !!obj.mainSn)
          newCraneList.forEach((item) => {
            const {id, alias, towerHeight, craneType, jibArmLength, sectionLength, maxLoad, craneFactoryName, craneModelName, actualTowerHeight, actualBalanceArmLength, actualSectionHeight} = item
            const customCrane = customObj[id]
            if (customCrane) {
              const {screenX, screenY, armLength, balanceArmLength, areaList} = customCrane
              const hasVideo = !!this.craneCameraObj[id].length
              const newObj = {
                craneId: id,
                screenX,
                screenY,
                armLength,
                towerHeight,
                craneType,
                areaList,
                balanceArmLength,
                name: alias,
                hasVideo,
                jibArmLength,
                sectionLength,
                maxLoad,
                craneFactoryName,
                craneModelName,
                alias,
                actualTowerHeight,
                actualBalanceArmLength,
                actualSectionHeight
              }
              this.data[id] = newObj
              initOk.push(newObj)
            }
          })
          if (initOk.length) {
            this.craneList = [...this.craneList, ...initOk]
          }
          const newIndex = index + 1
          if (newIndex < this.projects.length) {
            this.getProjectCrane(this.projects[newIndex].projectId, newIndex)
          } else if (this.craneList.length) {
            this.cranes = this.craneList
            this.craneObj = this.cranes[0]
          }
        }
      })
    },
    getProjectGroupRunData () {
      this.getRunData(this.projects[0].projectId, 0)
    },
    getRunData (projectId, index) {
      const cranes = this.projectCranes[this.currentProjectId]
      getRunData(projectId).then(res => {
        const {data, code} = res
        if (code === 200) {
          const newData = []
          data.forEach((obj) => {
            const {id, angle, loadWeight} = obj
            const isCurrentProjectCrane = cranes.includes(id)
            let oldObj = this.data[id]
            if (oldObj) {
              newData.push({...obj, ...{craneId: id, rotationAngle: angle, loadValue: loadWeight, isCurrentProjectCrane}})
            }
          })
          this.runDataList = [...this.runDataList, ...newData]
          const newIndex = index + 1
          if (newIndex < this.projects.length) {
            this.getRunData(this.projects[newIndex].projectId, newIndex)
          } else {
            this.runData = this.runDataList
          }
        }
      })
    },
    callRequest () {
      this.clearLoopTimer()
      this.clearCraneTimer()
      this.getProjectGroupRunData()
      this.timerRequest()
      this.timerClickRequest()
    },
    // 实时数据轮询
    timerRequest () {
      this.loopTimer = setInterval(() => {
        this.getProjectGroupRunData()
      }, 10000)
    },
    // 塔机自动轮询
    timerClickRequest () {
      this.craneTimer = setInterval(() => {
        this.switchClickCrane()
      }, 15000) // 30秒轮询塔机基础信息
    },
    // 一分钟轮询一个项目
    timerProjectRequest () {
      this.projectRequestTimer = setInterval(() => {
        if (this.currentProjectIndex < this.projects.length) {
          this.currentProjectId = this.projects[this.currentProjectIndex].projectId
          this.getCurrentProject()
          this.getProjectGroupRunData()
          this.currentProjectIndex++
        } else {
          this.currentProjectIndex = 0
          this.currentProjectId = this.projects[0].projectId
          this.getCurrentProject()
          this.getProjectGroupRunData()
        }
      }, 60000) // 1分钟
    },
    switchClickCrane () {
      const dataVal = Object.values(this.data)
      const len = dataVal.length
      if (this.clickIndex < len - 1) {
        this.craneObj = dataVal[this.clickIndex]
        this.clickIndex++
      } else {
        this.craneObj = dataVal[this.clickIndex]
        this.clickIndex = 0
      }
    },
    getRealData () {
      const startDate = dayjs().subtract(1, 'd').format(formatter)
      const endDate = dayjs().format(formatter)
      const params = {startDate, endDate, nodeId: this.currentProjectId}
      getRealData(params).then((res) => {
        const {data, code} = res
        if (code === 200) {
          const {onlineTotal = 0, total = 0, vtotal = 0, stotal = 0} = data
          const params = {
            craneTotal: total,
            online: onlineTotal,
            num110s: stotal,
            numV610: vtotal
          }
          const onlineRate = !total ? 0 : onlineTotal / total * 100
          this.craneOverview = {...this.craneOverview, ...params}
          this.staticsInfo = {...this.staticsInfo, ...{currentOnlineRate: onlineRate}}
        }
      })
    },
    getProjectDayStaticData () {
      const startDate = dayjs().subtract(1, 'd').format(formatter)
      const endDate = dayjs().format(formatter)
      const {id, companyId} = this.currentProjectInfo
      const params = {startDate, endDate, nodeId: companyId}
      getDayStaticData(params).then(res => {
        const {data, code} = res
        if (code === 200) {
          let {list = []} = data
          let preOnlineRate = 0
          let currentAlarm = 0
          let currentTaJunAlarm = 0
          let preAlarm = 0
          let currentPeccancy = 0
          let currentTaJunPeccancy = 0
          let prePeccancy = 0
          let currentHangTimes = 0
          let currentTaJunHangTimes = 0
          let preHangTimes = 0
          let currentWorkTime = 0
          let currentTaJunWorkTime = 0
          let preWorkTime = 0
          list.forEach((obj) => {
            const {nodeId, statDate: factStartDate, totalCrane, totalAlarm, avgAlarm, totalPeccancy, avgPeccancy, avgTotal, total, onlineRate, workDuration} = obj
            if (nodeId === id) {
              const avg = Math.round(totalCrane ? workDuration / totalCrane : 0)
              const result = factStartDate === startDate
              if (!result) {
                currentAlarm = totalAlarm
                currentTaJunAlarm = avgAlarm
                currentPeccancy = totalPeccancy
                currentTaJunPeccancy = avgPeccancy
                currentHangTimes = total
                currentTaJunHangTimes = avgTotal
                currentWorkTime = workDuration
                currentTaJunWorkTime = avg
              } else {
                preOnlineRate = onlineRate * 100
                preAlarm = totalAlarm
                prePeccancy = totalPeccancy
                preHangTimes = total
                preWorkTime = workDuration
              }
            }
          })
          this.staticsInfo = {...this.staticsInfo,
            ...{
              preOnlineRate,
              currentAlarm,
              currentTaJunAlarm,
              preAlarm,
              currentPeccancy,
              currentTaJunPeccancy,
              prePeccancy,
              currentHangTimes,
              currentTaJunHangTimes,
              preHangTimes,
              currentWorkTime,
              currentTaJunWorkTime,
              preWorkTime
            }}
        }
      })
    },
    getDayStaticData () {
      const startDate = dayjs().subtract(1, 'd').format(formatter)
      const endDate = dayjs().format(formatter)
      const params = {startDate, endDate, nodeId: this.currentProjectId}
      getDayStaticData(params).then(res => {
        const {data, code} = res
        if (code === 200) {
          const {list = []} = data
          const alarmChartData = []
          const peccancyChartData = []
          list.forEach((obj) => {
            const {nodeName, statDate: factStartDate, totalAlarm, totalPeccancy} = obj
            const result = factStartDate === startDate
            if (!result) {
              alarmChartData.push({title: nodeName, total: totalAlarm})
              peccancyChartData.push({title: nodeName, total: totalPeccancy})
            }
          })
          this.alarmChartData = alarmChartData.sort(compare('total', 0))
          this.peccancyChartData = peccancyChartData.sort(compare('total', 0))
        }
      })
    },
    // 获取报警统计数据
    getAlarmDetail () {
      const beginTime = `${dayjs().format(formatter)} 00:00:00`
      const endTime = `${dayjs().format(formatter)} 23:59:59`
      const params = {nodeId: this.currentProjectId, ticketType: 2, subTicketType: -1, pageSize: 20, pageNumber: 0, beginTime, endTime}
      const data = []
      getAlarmDetail(params).then((res) => {
        const newData = res.data.filter((obj, index) => index < 18)
        newData.forEach((obj) => {
          const {craneName, startTime, endTime, alarmCode} = obj
          const content = detailType[`${alarmCode}`]
          const newStartTime = dayjs(startTime).format(formatter2)
          const newEndTime = !endTime ? '--' : dayjs(endTime).format(formatter2)
          data.push({craneName, startTime: newStartTime, endTime: newEndTime, content})
        })
        this.alarmList = data
      })
    },
    // 获取违章统计数据
    getPeccancyDetail () {
      const beginTime = `${dayjs().format(formatter)} 00:00:00`
      const endTime = `${dayjs().format(formatter)} 23:59:59`
      const params = {nodeId: this.currentProjectId, ticketType: 3, subTicketType: -1, pageSize: 20, pageNumber: 0, beginTime, endTime}
      const data = []
      getAlarmDetail(params).then((res) => {
        const newData = res.data.filter((obj, index) => index < 18)
        newData.forEach((obj) => {
          const {craneName, startTime, endTime, alarmCode} = obj
          const content = detailType[`${alarmCode}`]
          const newStartTime = dayjs(startTime).format(formatter2)
          const newEndTime = !endTime ? '--' : dayjs(endTime).format(formatter2)
          data.push({craneName, startTime: newStartTime, endTime: newEndTime, content})
        })
        this.peccancyList = data
      })
    },
    init () {
      const params = this.getUrlParams()
      const {projectGroupId, token} = params
      if (!projectGroupId || !token) {
        this.$router.push('/')
      } else {
        sessionStorage.setItem('authorization', token)
        this.projectGroupInfo.id = projectGroupId
        this.getProjectGroup()
      }
    },
    // 获取url参数
    getUrlParams () {
      const params = {}
      const href = window.location.href
      const searchIndex = href.indexOf('?')
      if (searchIndex > -1) {
        const search = href.substring(searchIndex + 1)
        const paramsStr = search.split('&')
        paramsStr.forEach(res => {
          const str = res.split('=')
          params[str[0]] = str[1]
        })
      }
      return params
    },
    // 铺满全屏
    resizeFull () {
      const ratioX = window.innerWidth / 1920
      const ratioY = window.innerHeight / 1080
      $('#home-bg').css({
        transform: 'scale(' + ratioX + ', ' + ratioY + ')',
        transformOrigin: 'left top',
        backgroundSize: '100% 100%'
      })
    },
    addEvenListener () {
      const self = this
      window.onresize = function () {
        self.isScreenChange = Math.random()
        self.resizeFull()
      }
    },
    // 塔的的轮询
    clearCraneTimer () {
      if (this.craneTimer) clearInterval(this.craneTimer)
    },
    clearLoopTimer () {
      if (this.loopTimer) clearInterval(this.loopTimer)
    },
    clearProjectRequestTimer () {
      if (this.projectRequestTimer) clearInterval(this.projectRequestTimer)
    },
    // 刷新token
    refreshTokenRequest () {
      this.refreshTimer = refreshToken().then(res => {
        const {data, code} = res
        if (code === 200) {
          sessionStorage.setItem('authorization', data)
        }
      })
    },
    // 定时刷新
    refreshTokenTimer () {
      setInterval(() => {
        this.refreshTokenRequest()
      }, 86400)
    },
    clearRefreshTokenTimer () {
      if (this.refreshTimer) clearInterval(this.refreshTimer)
    }
  },
  mounted () {
    this.addEvenListener()
    this.resizeFull()
    this.init()
    this.refreshTokenTimer()
  },
  // 实时数据10秒，塔机轮询2分钟， 统计轮询5分钟， 报警统计1分钟
  destroyed () {
    this.clearLoopTimer()
    this.clearCraneTimer()
    this.clearProjectRequestTimer()
    this.clearRefreshTokenTimer()
  }
}
</script>

<style scoped lang="scss">
  #home-bg{
    width:1920px;
    height:1080px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home.vue